export default __webpack_public_path__ + "static/media/delink.561c1c31.png";